import { useQuery } from '@tanstack/react-query';
import { getPrescriptionService } from '../../../domains/prescriptions';

/**
 * 환자의 마지막 처방전 조회.
 * 응답: { id, source, hospital_name, medications, ... }
 */
export const useLastPrescription = (userId: number | string | null | undefined) => {
  return useQuery({
    queryKey: ['last-prescription', userId],
    enabled: userId != null && userId !== '',
    queryFn: async () => {
      const res = await getPrescriptionService().getLastPrescription(userId);
      return res?.data?.data ?? res?.data ?? null;
    },
  });
};
